import {
  BOOLEAN_OPTIONS,
  booleanOptionLabels,
} from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";
import createLocalizationsSchema from "@/schema/WebDataManagement/MasterData/Localizations/createLocalizationsSchema";
import * as Yup from "yup";

const AnnouncementShcema = (localeCodes, isEdit = false) =>
  Yup.object().shape({
    sport_id: Yup.string().label("Sport ID").required(),
    localizations: createLocalizationsSchema(localeCodes),
    page: Yup.string().label("Page").required(),
    name: Yup.string().label("Name").required(),
    is_closable: Yup.boolean()
      .label("Is Closable")
      .required()
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Is Closable must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    type: Yup.string().label("Type").required(),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
  });

export default AnnouncementShcema;
